import React from 'react'
// import { ReactComponent as Close } from '../../../assets/icons/assets/assets/assets/assets/Close.svg'
// import { ReactComponent as BTCIcon } from '../../../assets/icons/assets/assets/assetsBtc.svg'
import Close from '../../../assets/icons/assets/Close.png'
import BTCIcon from '../../../assets/icons/assets/assetsBtc.png'
import { ReactComponent as USDIcon } from '../../../assets/icons/assets/header_dollar.svg'
import './DepositBlock.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Deposit = ({state, setState}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    return (
        <div className={state == true ? "Deposit DepositActive" : "Deposit"}>
            <div className="DepositHeadline">
                <div className="textBlock">
                    <h2>{t("depositBlock.deposit")}</h2>
                    <p>{t("depositBlock.depostType")}</p>
                </div>
                {/* <Close onClick={()=>{setState(false)}}/> */}
                <img src={Close} alt="" onClick={()=>{setState(false)}} />
            </div>
            <div className="deposit-wrapper">
                <div className="deposit-block" onClick={() => {
                    navigate("/account/deposit")
                }}>
                    <USDIcon/>
                    <div className="textBlock">
                        <h2>{t("depositBlock.fiat")}</h2>
                        <p>{t("depositBlock.fiatChange")}</p>
                    </div>
                </div>
                <div className="deposit-block" onClick={() => {
                    navigate("/account/deposit-crypto")
                }}>
                    {/* <BTCIcon /> */}
                    <img src={BTCIcon} alt=""/>
                    <div className="textBlock">
                        <h2>{t("depositBlock.crypto")}</h2>
                        <p>{t("depositBlock.cryptoChange")}</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Deposit